var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 640 480"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#ffce00","d":"M0 320h640v160H0z"}}),_c('path',{attrs:{"d":"M0 0h640v160H0z"}}),_c('path',{attrs:{"fill":"#d00","d":"M0 160h640v160H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }